"use strict";
/* eslint-disable import/no-commonjs */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-var-requires */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoService = exports.Authenticator = exports.addAuthVars = exports.Authorization = exports.Roles = exports.LoginType = exports.hasScope = exports.Scopes = exports.Scope = exports.AUTHORITY_URL = exports.getBearerToken = exports.Headers = void 0;
const detect_node_1 = __importDefault(require("detect-node"));
var headers_1 = require("./headers");
Object.defineProperty(exports, "Headers", { enumerable: true, get: function () { return headers_1.Headers; } });
Object.defineProperty(exports, "getBearerToken", { enumerable: true, get: function () { return headers_1.getBearerToken; } });
var oidc_1 = require("./oidc");
Object.defineProperty(exports, "AUTHORITY_URL", { enumerable: true, get: function () { return oidc_1.AUTHORITY_URL; } });
Object.defineProperty(exports, "Scope", { enumerable: true, get: function () { return oidc_1.Scope; } });
Object.defineProperty(exports, "Scopes", { enumerable: true, get: function () { return oidc_1.Scopes; } });
Object.defineProperty(exports, "hasScope", { enumerable: true, get: function () { return oidc_1.hasScope; } });
var login_types_1 = require("./config/login-types");
Object.defineProperty(exports, "LoginType", { enumerable: true, get: function () { return login_types_1.LoginType; } });
__exportStar(require("./config-types"), exports);
__exportStar(require("./config/roles"), exports);
__exportStar(require("./config/langs"), exports);
__exportStar(require("./config/trees"), exports);
__exportStar(require("./config/perms"), exports);
exports.Roles = __importStar(require("./roles"));
var authz_1 = require("./authz");
Object.defineProperty(exports, "Authorization", { enumerable: true, get: function () { return authz_1.Authorization; } });
var restrict_1 = require("./restrict");
Object.defineProperty(exports, "addAuthVars", { enumerable: true, get: function () { return restrict_1.addAuthVars; } });
// isomorphic includes
if (detect_node_1.default) {
    global.__non_webpack_require__ = require;
}
const { Authenticator } = detect_node_1.default
    ? __non_webpack_require__("./authn/node")
    : require("./authn/browser");
exports.Authenticator = Authenticator;
const { UserInfoService } = detect_node_1.default
    ? __non_webpack_require__("./userinfo/node")
    : require("./userinfo/browser");
exports.UserInfoService = UserInfoService;
